import dayjs from 'dayjs';
import { MapUtils } from '../../utility/map-utils.js';
import { TimeZone } from '../../time/timezone.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';

export class CouponCode extends DataModel {
  static readonly TYPE_ID: string = 'bb964b0a3f5a4a338c19d2b3efbcb1ce';

  constructor(
    public readonly redeemDate: dayjs.Dayjs,
    public readonly code: string,
  ) {
    super();
  }

  get $typeId(): string {
    return CouponCode.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): CouponCode {
    return new CouponCode(
        context.decodeDate(MapUtils.get<number>(map, 'redeemDate')),
        MapUtils.get<string>(map, 'code'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'redeemDate': context.encodeDate(this.redeemDate),
      'code': this.code,
      'formattedRedeemDate': this.redeemDate.format('yyyy.MM.dd. HH:mm'),
    };
  }

  clone(): this {
    return new CouponCode(
        TimeZone.cloneDate(this.redeemDate),
        this.code,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.redeemDate === this.redeemDate &&
        other.code === this.code;
  }
}

export class CouponCodeBuilder extends DataModelBuilder<CouponCode> {
  build(context: SerializationContext, map: SerializedData): CouponCode {
    return CouponCode.fromMap(context, map);
  }
}
